import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULTS = {
  shop_name: "Tendres Tétées",
  tagline: "La qualité pour le plaisir d'allaiter",
  phone: "",
  whatsapp: "",
  delivery_fee: 0,
  announcement: "Offre de lancement : -10 % sur toute la boutique avec le code",
  banner_active: false,
  banner_code: "MAMAN10",
  hero_overline: "La 1ère boutique en ligne dédiée à l'allaitement au Sénégal",
  hero_title_1: "Nourrir la vie",
  hero_title_2: "en toute sérénité",
  hero_sub: "",
  seo_title: "Tendres Tétées | La 1ère boutique en ligne dédiée à l'allaitement au Sénégal",
  seo_description: "Matériel d'allaitement à Dakar : tire-lait Medela, recueil de lait Haakaa, coquillages d'allaitement, crème lanoline, sachets de conservation, coussinets lavables et compléments Calmosine. Livraison à domicile à Dakar, paiement à la livraison.",
  address: "Dakar, Sénégal",
  google_reviews_url: "",
  svc_domicile_price: 35000,
  svc_domicile_duration: "1h",
  svc_visio_price: 25000,
  svc_visio_duration: "1h",
  svc_prenatal_price: 50000,
  svc_prenatal_duration: "2h en visio",
  svc_reprise_price: 45000,
  svc_reprise_duration: "1h30 en visio",
};

const SettingsCtx = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/settings")
      .then((res) => setSettings({ ...DEFAULTS, ...res.data }))
      .catch(() => {});
  }, []);

  return (
    <SettingsCtx.Provider value={settings}>{children}</SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
